const getCrmRequestImages = (state: any) => {
  return state?.crmRequests.crmRequestImages;
};

export default {
  getCrmRequestImages,
};
